export const aboutData = {
  brandName: "开云体育",
  slogan: "值得信赖的体育娱乐平台",
  intro: "开云体育是全球领先的在线体育娱乐平台，致力于为广大体育爱好者提供安全、专业、便捷的一站式体育赛事投注服务。自成立以来，平台始终秉持「用户至上、诚信经营」的核心理念，赢得了数百万用户的信赖与支持。",
  story: "开云体育由一群热爱体育的行业专家于2015年创立，经过多年发展，已成为亚洲最具影响力的体育娱乐品牌之一。平台汇聚了来自全球的顶尖技术人才和运营团队，持续优化产品体验，为用户提供极致的体育娱乐服务。",
  values: [
    { title: "诚信为本", description: "始终坚持公平公正的运营原则，所有投注结果公开透明，接受第三方独立审计监督。" },
    { title: "技术创新", description: "持续投入技术研发，采用大数据和AI技术为用户提供精准的赛事分析和赔率预测。" },
    { title: "用户至上", description: "7×24小时多语言客服支持，快速存取款服务，致力于为每一位用户创造卓越体验。" },
    { title: "安全第一", description: "国际顶尖加密技术保障用户数据与资金安全，多重风控体系防范各类风险。" },
  ],
  certifications: [
    { name: "国际博彩协会认证", icon: "ri-shield-check-line", description: "通过国际博彩协会(IBA)严格审核，符合全球最高行业标准" },
    { name: "数据安全认证", icon: "ri-lock-line", description: "获得ISO 27001信息安全管理体系认证，用户数据安全有保障" },
    { name: "公平游戏认证", icon: "ri-scales-line", description: "经第三方独立机构认证，所有游戏和投注结果公平公正" },
    { name: "合法经营牌照", icon: "ri-government-line", description: "持有正规政府颁发的合法经营牌照，受法律严格监管" },
  ],
  stats: [
    { value: "500万+", label: "注册用户" },
    { value: "50+", label: "覆盖国家/地区" },
    { value: "99.9%", label: "系统稳定性" },
    { value: "24/7", label: "客户服务" },
  ],
  contactInfo: {
    email: "service@kaiyunsports.com",
    phone: "400-888-9999",
    wechat: "kaiyunsports",
    address: "香港中环金融街8号国际金融中心",
  },
};

export const seoTextData = {
  mainKeyword: "开云体育下载",
  relatedKeywords: ["开云体育APP下载", "开云体育官方下载", "开云体育安卓下载", "开云体育iOS下载", "开云体育最新版下载", "开云体育手机版下载"],
  description: "开云体育下载官方入口，支持iOS与Android系统，一键安装正版开云体育APP。畅享海量体育赛事直播、实时赔率、安全存取款及专属会员福利。开云体育APP下载安全便捷，开云体育官方下载认准唯一官网。",
};